import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NurseriesComponent } from './nurseries/nurseries.component';
import { NurseryProductsComponent } from './nursery-products/nursery-products.component';
import { PlantsComponent } from './plants/plants.component';
import { PollinatorComponent} from './pollinators/pollinators.component';

const routes: Routes = [
  { path: '', component: LandingPageComponent },        // Home
  { path: 'nurseries', component: NurseriesComponent }, // Nursery page
  { path: 'nursery/:id/products', component: NurseryProductsComponent }, // Nursery products page
  { path: 'plants', component: PlantsComponent }, // Plants page
  { path: 'pollinators', component: PollinatorComponent }, // Plants page
  { path: '**', redirectTo: '' }                        // Catch-all fallback
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
